import { getBirthDisabledDates, getDefaultPhoneCode } from '@utils/index';
import { EUserType } from '@xeppt/xeppt-sdk/types/user';

import { ESchedulePaymentType } from '@enum';
import { EScheduleFrequency } from '@xeppt/xeppt-sdk/types/schedule';
import { formatDateWithoutTimezone, getLocalMidnight, setToCurrentHour } from '@utils/date';

export const defaultAddressData = {
    country: '',
    city: '',
    address_2: '',
    address_1: '',
    zip_code: '',
    region: ''
};

export const defaultBusinessData = {
    company_name: '',
    tradingName: '',
    registration_number: '',
    category: '',
    size: '',
    website: ''
};

export const defaultPersonalInfo = {
    profile: {
        first_name: '',
        last_name: '',
        birth_date: getBirthDisabledDates(),
        occupancy: ''
    },
    billing_address: defaultAddressData
};

export const defaultPersonalSignUpData = {
    email: '',
    phone_number: '',
    phone_code: getDefaultPhoneCode(),
    profile: {
        first_name: '',
        last_name: '',
        birth_date: undefined,
        occupancy: '',
        tag: ''
    },
    billing_address: defaultAddressData,
    type: EUserType.INDIVIDUAL,
    verificationCode: '',
    code: ''
};

export const defaultBusinessSignUpData = {
    email: '',
    phone_number: '',
    phone_code: getDefaultPhoneCode(),
    profile: {
        first_name: '',
        last_name: '',
        birth_date: undefined,
        occupancy: '',
        residence: '',
        tag: ''
    },
    business_address: defaultAddressData,
    registration_address: defaultAddressData,
    registrationSameBusiness: false,
    trading_address: defaultAddressData,
    tradingSameBusiness: false,
    type: EUserType.BUSINESS,
    verificationCode: '',
    business: {
        company_name: '',
        tradingName: '',
        registration_number: '',
        category: '',
        business_category: '',
        size: '',
        website: ''
    },
    code: ''
};

export const defaultSignInData = {
    email: '',
    password: '',
    mfaCode: ''
};

export const defaultForgotPassword = {
    email: '',
    phone_code: getDefaultPhoneCode(),
    phone_number: '',
    password: '',
    password_confirm: ''
};

export const defaultProfileSettingsData = {
    ...defaultPersonalInfo,
    type: EUserType.BUSINESS
};

export const defaultLinkCard = {
    first_name: '',
    last_name: '',
    card_number: '',
    expire: '',
    code: ''
};

export const defaultLinkBank = {
    account_number: '',
    transit_number: '',
    account_name: '',
    bank_number: ''
};

export const addressValidationErrors = (localization: (value: string) => string) => ({
    address_1: localization('address_1'),
    address_2: localization('address_2'),
    zip_code: localization('zip_code'),
    city: localization('city'),
    country: localization('country'),
    region: localization('region')
});

export const defaultRequestCard = {
    shipping_address: defaultAddressData,
    first_name: '',
    last_name: '',
    email: '',
    middle_name: '',
    agree: false,
    alias: undefined,
    //@ts-ignore
    birth_date: undefined as Date,
    occupation: '',
    status: '',
    phone_number: '',
    permanent_residence: defaultAddressData,
    cell_phone: '',
    citizenship: '',
    tax_info: [
        {
            country: '',
            tin: '',
            reason_id: '',
            reason: '',
            no_tin: false
        }
    ]
};

export const defaultPaymentData = {
    paymentType: ESchedulePaymentType.PAYMENTS_DATE,
    paymentFrequency: EScheduleFrequency.ONCE,
    amount: '',
    amount_result: '',
    isSchedule: false,
    paymentsEndDate: undefined,
    isInfinitePayment: false,
    number_of_payments: 1,
    next_payment_at: setToCurrentHour(new Date()),
    account: ''
};
